enum FilterOperator {
  IS = 'is',
  ALL = 'all',
  ANY = 'any',
  IS_NOT = 'is_not',
  NONE_OF = 'none_of',
  CONTAINS = 'contains',
  NOT_CONTAINS = 'not_contains',
  LESS_THAN = 'less_than',
  GREATER_THAN = 'greater_than',
  BETWEEN = 'between',
  IS_NOT_NULL = 'is_not_null',
  IS_NULL = 'is_null',
}

export default FilterOperator;
